import React, { useState, useEffect } from 'react'
import SidebarComponent from 'pages/sidebar'
import ProfileCompletionGate from 'components/ProfileCompletionGate'
import './defaultLayout.scss'
import { getCookie } from 'services/cookies'

const DefaultLayout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const closeSidebar = () => {
    setSidebarOpen(false)
  }

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [sidebarOpen])

  return (
    <div className='default-layout'>
      <div className='mobile-header'>
        <button className='hamburger-btn' onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <span className='mobile-profile-name'>{getCookie('profile') || 'Mamboo'}</span>
        <div style={{ width: 38 }}></div>
      </div>
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={closeSidebar}
      />
      <SidebarComponent onNavigate={closeSidebar} sidebarOpen={sidebarOpen} />
      {/* Pembungkus eksplisit untuk area konten.
          Sebelumnya area konten dipilih lewat rantai `:not()` di CSS ("semua
          anak selain sidebar/header/overlay"). Rantai itu ikut menjaring
          elemen yang bukan konten: ModalImport selalu merender <div> pembungkus
          walau modalnya tertutup, dan satu halaman bisa memuat tiga di antaranya.
          Semuanya ikut kebagian `flex: 1`, sehingga lebar halaman terbagi rata
          dengan div-div kosong itu dan tabel jadi sesempit seperempat layar. */}
      <main className="page-content">{props.children}</main>
      <ProfileCompletionGate />
    </div>
  )
}

export default DefaultLayout
